import { DeliveryCompany } from "../../../entity/DeliveryCompany";
import { StoreDeliveryConfigurations } from "../../../entity/StoreDeliveryConfiguration";
import { CONSTANTS } from "../../../utils/Constants";
import { Method, ROUTES } from "../../configuration/Configuration";
import { fetchAPI } from "../../configuration/MainService";
import { DeliveryCompanyDto } from "../../dto/DeliveryCompany.Dto";
import { DeliveryMapper } from "../../mapper/DeliveryMapper";

class WSDelivery {
  private static instance: WSDelivery;

  private constructor() { }

  static getInstance(): WSDelivery {
    if (!this.instance) {
      this.instance = new WSDelivery();
    }
    return this.instance;
  }

  connect() { }

  async getDeliveryCompanies(): Promise<DeliveryCompany[]> {
    try {
      const url = `${ROUTES.DELIVERY_COMPANIES}`;
      const response = await fetchAPI<DeliveryCompanyDto[]>({
        url,
        method: Method.GET,
        isAuthenticated: true,
      });
      return DeliveryMapper.mapToDelivery(response.data);
    } catch (error) {
      throw error;
    }
  }

  async createDeliveryCompany(company: DeliveryCompany): Promise<void> {
    try {
      const url = ROUTES.DELIVERY_COMPANIES + ROUTES.CREATE;
      await fetchAPI({
        url,
        method: Method.POST,
        isAuthenticated: true,
        params: company,
      });
    } catch (error) {
      throw error;
    }
  }

  async updateDeliveryCompany(company: DeliveryCompany): Promise<void> {
    try {
      const url = ROUTES.DELIVERY_COMPANIES + company.id;
      const response = await fetchAPI({
        url,
        method: Method.PUT,
        isAuthenticated: true,
        params: company,
      });
    } catch (error) {
      throw error;
    }
  }

  async deleteDeliveryCompany(id: string): Promise<void> {
    try {
      const url = ROUTES.DELIVERY_COMPANIES + id;
      await fetchAPI({
        url,
        method: Method.DELETE,
        isAuthenticated: true,
      });
    } catch (error) {
      throw error;
    }
  }

  async deleteFragmentById(id: string): Promise<void> {
    try {
      const url = ROUTES.DELIVERY_COMPANIES + ROUTES.DELETE_FRAGMENT_BY_ID + id;
      await fetchAPI({
        url,
        method: Method.DELETE,
        isAuthenticated: true,
      });
    } catch (error) {
      throw error;
    }
  }

  async connectDeliveryCompany(
    storeConfig: StoreDeliveryConfigurations,
  ): Promise<void> {
    try {
      const url = ROUTES.DELIVERY_COMPANIES + ROUTES.CONNECT;
      await fetchAPI({
        url,
        method: Method.POST,
        isAuthenticated: true,
        params: storeConfig,
      });
    } catch (error) {
      throw error;
    }
  }

  async updateDeliveryCompanyConfigurations(
    storeConfig: StoreDeliveryConfigurations,
  ): Promise<void> {
    try {
      const url = ROUTES.DELIVERY_COMPANIES + ROUTES.CONNECT + ROUTES.UPDATE;
      await fetchAPI({
        url,
        method: Method.PUT,
        isAuthenticated: true,
        params: storeConfig,
      });
    } catch (error) {
      throw error;
    }
  }

  async getStoreDeliveryConfigurationsByStoreID(
    storeId: string,
  ): Promise<StoreDeliveryConfigurations[]> {
    try {
      const url = ROUTES.DELIVERY_COMPANIES + ROUTES.CONNECT + storeId;
      const response = await fetchAPI<StoreDeliveryConfigurations[]>({
        url,
        method: Method.GET,
        isAuthenticated: true,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export const WSDeliveryInstance = WSDelivery.getInstance();
